export default __webpack_public_path__ + "static/media/Meditation-bell-sound-effect.72379061.mp3";